/* global bootstrap */
const abortControllerMap = new Map();
document.addEventListener('DOMContentLoaded', function () {
  filterSelectedOptionCTA();

  const navTabItems = document.querySelectorAll('.tabs-container ul#navTabs li.nav-item button.nav-link');
  if (navTabItems) {
    navTabItems.forEach((button) => {
      button.addEventListener('click', (e) => {
        const id = e.target.closest('[id]').id || button.id;
        filterSelectedOptionCTA(id);
      });
      button.addEventListener('keydown', (e) => {
        if (e.key === ' ' || e.key === 'Enter') {
          const id = e.target.closest('[id]').id || button.id;
          filterSelectedOptionCTA(id);
        }
      });
    });
  }

  document.addEventListener('studentInstructorToggleGroupChange', (e) => {
    if (e.detail?.value !== 'student') {
      return;
    }
    const studentTabButton =
      document.querySelector('#navTabs.student-nav-tabs .nav-link.active') ||
      document.querySelector('#navTabs.student-nav-tabs .nav-link');
    if (studentTabButton) {
      filterSelectedOptionCTA(studentTabButton.id);
    }
  });
});

function filterSelectedOptionCTA(id) {
  let activeTab;
  if (id) {
    activeTab = document.querySelector(`[aria-labelledby="${id}"].tab-pane`);
  } else {
    activeTab = document.querySelector('.mhecomm-purchase-options .tab-content .tab-pane.active');
  }

  let multiDropdownOptions;
  let selectedDropdown;
  let dropdownSelectedTextElement;
  let dropdownToggle;

  if (activeTab) {
    multiDropdownOptions = activeTab.querySelectorAll('.multiple-purchase-option-dropdown .dropdown-item');
    if (!multiDropdownOptions.length) {
      return;
    }
    initActiveStyleToggle(multiDropdownOptions);
    appendAriaLabelForDisabledOptions(multiDropdownOptions);
    selectedDropdown = activeTab.querySelector('.multiple-purchase-option-dropdown .dropdown-item.current');
    selectedDropdown = selectedDropdown || multiDropdownOptions[0];
    dropdownSelectedTextElement = activeTab.querySelector('.multiple-purchase-option-dropdown .dropdown-selected-text');
    dropdownToggle = activeTab.querySelector('.multiple-purchase-option-dropdown .dropdown-toggle');
  }

  const preComputedOfferList = populateDropdownUniqueOfferId(multiDropdownOptions);
  if (multiDropdownOptions && multiDropdownOptions.length > 0) {
    multiDropdownOptions.forEach(function (item) {
      if (item) {
        // Handle click events
        item.addEventListener('click', function () {
          const target = this.getAttribute('data-add-to-cart-target');
          toggleActiveStatusForDropdownItems(
            target,
            multiDropdownOptions,
            preComputedOfferList,
            dropdownSelectedTextElement
          );
          focusDropdownToggleAfterClick(dropdownToggle);
        });

        // Handle keyboard events (Space and Enter)
        item.addEventListener('keydown', function (e) {
          if (e.key === ' ' || e.key === 'Enter') {
            e.preventDefault();
            const target = this.getAttribute('data-add-to-cart-target');
            toggleActiveStatusForDropdownItems(
              target,
              multiDropdownOptions,
              preComputedOfferList,
              dropdownSelectedTextElement
            );

            if (dropdownToggle) {
              const existingInstance = bootstrap.Dropdown.getInstance(dropdownToggle);
              const bsDropdown = existingInstance || new bootstrap.Dropdown(dropdownToggle);
              if (bsDropdown) {
                bsDropdown.hide();
              }
              focusDropdownToggleAfterClick(dropdownToggle);
            }
          }
        });
      }
    });
  }
  let uniqueOfferId;
  if (selectedDropdown) {
    uniqueOfferId = selectedDropdown.getAttribute('data-add-to-cart-target');
  }

  // Early return if no active dropdown found
  if (!selectedDropdown || !uniqueOfferId) {
    return;
  }

  // filtering CTA on page load
  toggleListPriceColumn(preComputedOfferList, uniqueOfferId);
}

function focusDropdownToggleAfterClick(dropdownToggle) {
  if (dropdownToggle) {
    dropdownToggle.focus();
  }
}

function populateDropdownUniqueOfferId(dropdownOptions) {
  const list = [];
  if (dropdownOptions && dropdownOptions.length > 0) {
    dropdownOptions.forEach(function (option) {
      if (option) {
        const target = option.getAttribute('data-add-to-cart-target');
        if (target) {
          list.push(target);
        }
      }
    });
  }
  return list;
}

function toggleListPriceColumn(list, offerId) {
  list.forEach(function (item) {
    if (item === offerId) {
      const element = document.querySelector(item);
      if (element) {
        element.classList.remove('d-none');
        element.classList.add('d-block');
      }
    } else {
      const elementToHide = document.querySelector(item);
      if (elementToHide) {
        elementToHide.classList.remove('d-block');
        elementToHide.classList.add('d-none');
      }
    }
  });
}

function toggleActiveStatusForDropdownItems(
  uniqueOfferId,
  dropdownOptions,
  preComputedList,
  dropdownSelectedTextElement
) {
  dropdownOptions.forEach(function (dropdown) {
    if (dropdown) {
      if (dropdown.classList.contains('disable')) {
        return;
      }
      const targetId = dropdown.getAttribute('data-add-to-cart-target');
      if (targetId === uniqueOfferId) {
        dropdown.setAttribute('aria-selected', 'true');
        toggleListPriceColumn(preComputedList, targetId);

        const optionInfo = dropdown.querySelector('.option-info');
        if (optionInfo) {
          const optionLabel = optionInfo.querySelector('.option-label');
          const optionListPrice = optionInfo.querySelector('.purchase-option-listed-price');
          if (optionLabel && optionListPrice) {
            toggleDropdownSelectedButtonText(
              optionLabel.innerText,
              optionListPrice.innerText,
              dropdownSelectedTextElement
            );
          }
        }

        togglePurchaseOptionLabel(dropdown);
      } else {
        dropdown.setAttribute('aria-selected', 'false');
      }
    }
  });
}

// Builds the button text via DOM nodes (not innerHTML) so authored text can never be reinterpreted as markup.
function toggleDropdownSelectedButtonText(optionLabelText, optionListPriceText, dropdownSelectedTextElement) {
  if (!optionLabelText || !optionListPriceText || !dropdownSelectedTextElement) {
    return;
  }
  const outerSpan = document.createElement('span');
  outerSpan.appendChild(document.createTextNode(optionLabelText));

  const priceSpan = document.createElement('span');
  priceSpan.className = 'd-none d-md-inline';
  priceSpan.appendChild(document.createTextNode(` - ${optionListPriceText}`));

  outerSpan.appendChild(priceSpan);
  dropdownSelectedTextElement.replaceChildren(outerSpan);
}

function togglePurchaseOptionLabel(dropdown) {
  // Get the selected dropdown option text
  let dropdownDurationText;
  let dropdownExpiryText;
  const optionInfoElement = dropdown.querySelector('.option-info .option-label');

  if (optionInfoElement) {
    dropdownDurationText = optionInfoElement.innerText;
  }
  const dropdownExpirySpan = dropdown.querySelector('.option-info .purchase-option-expiry-date');
  if (dropdownExpirySpan) {
    const dropdownMhecommElement = dropdownExpirySpan.querySelector('mhecomm-date-label');

    if (dropdownMhecommElement && dropdownMhecommElement.shadowRoot) {
      const dateElement = dropdownMhecommElement.shadowRoot.querySelector('.label-date');
      const labelElement = dropdownMhecommElement.shadowRoot.querySelector('.label-text');

      if (dateElement && labelElement) {
        const dateText = dateElement.innerText || '';
        const labelText = labelElement.innerText || '';
        dropdownExpiryText = labelText + ' ' + dateText;
      }
    }
  }

  const parentPoCardContainer = dropdown.closest('[data-expiry-pill-container="purchase-option-parent-po-card"]');

  if (parentPoCardContainer) {
    const purchaseOptionLabelDuration = parentPoCardContainer.querySelector(
      '.purchase-option-label .purchase-option-label-duration'
    );
    const purchaseOptionLabelExpiryDate = parentPoCardContainer.querySelector(
      '.purchase-option-label .border.rounded-pill'
    );

    if (purchaseOptionLabelDuration && dropdownDurationText) {
      purchaseOptionLabelDuration.innerText = dropdownDurationText;
    }

    if (purchaseOptionLabelExpiryDate && dropdownExpiryText) {
      const expirySpan = document.createElement('span');
      expirySpan.textContent = dropdownExpiryText;
      purchaseOptionLabelExpiryDate.replaceChildren(expirySpan);
    }
  }
}

// Dropdown open/close analytics now live in ecomm-ui-web-components'
// src/common/datalayer/rules/royalty-dropdown.ts (delegated show.bs.dropdown/hide.bs.dropdown listeners).

function appendAriaLabelForDisabledOptions(dropdownItems) {
  if (dropdownItems) {
    dropdownItems.forEach((dropdownItem) => {
      if (dropdownItem.classList.contains('disable')) {
        const originalText = dropdownItem.textContent.trim() || '';
        dropdownItem.setAttribute('aria-label', `${originalText}, disabled`);
      }
    });
  }
}

function initActiveStyleToggle(dropdownItems) {
  const options = [...dropdownItems];
  // Clean up existing listeners first
  cleanupEventListeners(options);

  setupDropdownOpenHandler(options);
  attachOptionEventHandlers(options);
}

function cleanupEventListeners(options) {
  options.forEach((optionEl) => {
    const controller = abortControllerMap.get(optionEl);
    if (controller) {
      // Remove from map after aborting
      controller.abort();
      abortControllerMap.delete(optionEl);
    }
  });
}

function setupDropdownOpenHandler(options) {
  const dropdown = options[0].closest('.dropdown');

  if (dropdown) {
    const dropdownToggle = dropdown.querySelector('.dropdown-toggle');
    if (dropdownToggle) {
      dropdownToggle.addEventListener('shown.bs.dropdown', function () {
        // Focus on the item that has 'current' class
        focusOnCurrentItem(options);
      });
    }
  }
}

function attachOptionEventHandlers(options) {
  options.forEach((optionEl, index) => {
    const controller = new AbortController();

    optionEl.addEventListener(
      'focus',
      function () {
        removeCurrentFromAll(options);
        setCurrentClass(options, index);
      },
      { signal: controller.signal }
    );

    optionEl.addEventListener(
      'mouseenter',
      function () {
        removeCurrentFromAll(options);
        setCurrentClass(options, index);
      },
      { signal: controller.signal }
    );

    optionEl.addEventListener(
      'mouseleave',
      function () {
        removeCurrentFromAll(options);
        restoreToSelected(options);
      },
      { signal: controller.signal }
    );

    // Store controller
    abortControllerMap.set(optionEl, controller);
  });
}

function setCurrentClass(options, index) {
  options[index].classList.add('current');
}

function removeCurrentFromAll(options) {
  options.forEach((opt) => opt.classList.remove('current'));
}

function restoreToSelected(options) {
  const selectedItem = options.find((opt) => opt.getAttribute('aria-selected') === 'true');
  if (selectedItem) {
    selectedItem.classList.add('current');
  }
}

function getCurrentItemIndex(options) {
  for (let i = 0; i < options.length; i++) {
    if (options[i].classList.contains('current')) {
      return i;
    }
  }
  return -1;
}

function focusOnCurrentItem(options) {
  const currentIndex = getCurrentItemIndex(options);
  if (currentIndex !== -1 && options[currentIndex]) {
    options[currentIndex].focus();
  }
}
